import React, { useState, useRef, useEffect } from 'react';
import Icon from '../Icon';


export default function Tab({
  id,
  tabId,
  tabRef,
  label,
  active,
  focused,
  onContextMenu,
  onClick,
  onClose,
  onLabelChange,
  canRename = true,
  isVersion = false,
  isChat = false,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  showInsertBefore,
  showInsertAfter
}) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(label);
  const inputRef = useRef(null);

  useEffect(() => {
    setText(label);
  }, [label]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const handleDoubleClick = (e) => {
    if (!canRename) return;
    e.stopPropagation();
    setEditing(true);
  };

  const commit = async () => {
    setEditing(false);

    const trimmed = text.trim();
    if (!trimmed || trimmed === label) return;

    // only pass the new label
    await onLabelChange(trimmed);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') commit();
    if (e.key === 'Escape') {
      setText(label);
      setEditing(false);
    }
  };

  return (
    <div
      ref={tabRef}
      id={id}
      className={`tab ${active ? 'active' : ''} ${focused ? 'focused' : ''} ${isVersion ? 'version-tab' : ''} ${isChat ? 'chat' : ''}`.trim()}
      draggable={!editing}
      onDragStart={e => {
        if (editing) {
          e.preventDefault();
          return;
        }
        onDragStart?.(e);
      }}
      onDragOver={e => onDragOver?.(e)}
      onDrop={e => { try { e.stopPropagation(); onDrop?.(e); } catch (err) { onDrop?.(e); } }}
      onDragEnd={e => { try { onDragEnd?.(e); } catch (err) {} }}
      onClick={() => !editing && onClick(tabId)}
      onContextMenu={e => {
        if (editing) return;
        onContextMenu?.(e);
      }}
      onDoubleClick={handleDoubleClick}
    >
      {showInsertBefore && <span className="insertLine before" />}
      {editing ? (
        <input
          ref={inputRef}
          value={text}
          onChange={e => setText(e.target.value)}
          onMouseDown={e => e.stopPropagation()}
          onPointerDown={e => e.stopPropagation()}
          onDragStart={e => e.preventDefault()}
          onBlur={commit}
          onKeyDown={handleKeyDown}
          className="tabInput"
        />
      ) : (
        <span className="tabLabel" data-tooltip={label} data-tooltip-placement="bottom">{label}</span>
      )}

      {showInsertAfter && <span className="insertLine after" />}

      <button
        className="iconButton small"
        onClick={e => {
          e.stopPropagation();
          onClose(tabId);
        }}
        aria-label="Close tab"
        data-tooltip="Close tab"
        data-tooltip-placement="bottom"
      >
        <Icon icon={'x'} className="icon small x" />
      </button>
    </div>
  );
}
